import { createContext, useContext, useState } from 'react';

export enum SweepCanvasSelectionMode {
  panOnDrag = 'PAN_ON_DRAG',
  selectOnDrag = 'SELECT_ON_DRAG',
}
interface CanvasControlsCtxType {
  selectionMode: SweepCanvasSelectionMode;
  setSelectionMode: React.Dispatch<React.SetStateAction<SweepCanvasSelectionMode>>;
}

export const CanvasControlsCtx = createContext<CanvasControlsCtxType>({
  selectionMode: SweepCanvasSelectionMode.panOnDrag,
  setSelectionMode: () => {},
});

export const CanvasControlsCtxProvider = ({ children }: { children: React.ReactNode }) => {
  const [selectionMode, setSelectionMode] = useState<SweepCanvasSelectionMode>(
    SweepCanvasSelectionMode.panOnDrag,
  );

  return (
    <CanvasControlsCtx.Provider value={{ selectionMode, setSelectionMode }}>
      {children}
    </CanvasControlsCtx.Provider>
  );
};

export const useCanvasControlsCtx = () => {
  return useContext(CanvasControlsCtx);
};
